exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-import-upload-tips{padding:0 20px;line-height:20px;list-style-type:decimal}.ele-import-upload-uploader{margin-top:20px;text-align:center}", ""]);

// exports
